import { render } from "./vegas27.vue?vue&type=template&id=e50c1448"
import script from "./vegas27.vue?vue&type=script&lang=js"
export * from "./vegas27.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__